import styled from  'styled-components' ;

export const TitleContainer = styled.div`
   display:  flex ;
   max-width: 100%;
   
`;

export const Paragraph = styled.p`
  text-align: justify;
`;

export const Title = styled.h2`
  width: 100%;
  margin: 0 10px;
  color:#345170;
`;

export const SubTitle = styled.div`
   color:#6c757d;
   font-size: 23px;
`;

export const Body = styled.div`
 
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
  margin:0 -18px 0 -18px;
`;

export const Main = styled.div`
  max-width: 1100px;
  margin:auto;
`;

export const PicTitle = styled.h3`
   font-weight: lighter;
`;
